/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import translate from '../../actions/translate';

const ErrorMessage = ({ times, loading }) => {
  const failedResSearch = useSelector(
    (state) => state.formState.failedRestaurantSearch
  );
  const failedPromo = useSelector((state) => state.formState.failedPromoCode);

  useEffect(() => {
    console.log('FAILED PROMO STATUS ', failedPromo);
  }, [failedResSearch, failedPromo]);

  return (
    <>
      {failedResSearch && times < 2 && !loading ? (
        <Typography variant="body1">
          {translate(
            'Unable to find restaurant, please type restaurant name followed by zip code'
          )}
        </Typography>
      ) : null}
      {failedResSearch && times >= 2 && !loading ? (
        <Typography variant="body1">
          {translate(
            "Still not the right one? Call our customer support line at 404-283-9768 and they'll help you get set up!"
          )}
        </Typography>
      ) : null}
      {failedPromo && !loading ? (
        <Typography>
          {translate('No restaurant associated with this promo code.')}{' '}
        </Typography>
      ) : null}
    </>
  );
};

export default ErrorMessage;
